import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  pure: false // <- se actualiza cuando cambie la fecha
})
export class TimeAgoPipe implements PipeTransform {

  transform(value: Date | string | number): string {
    // console.log(value);
    if (!value) return '';

    const now = new Date().getTime();
    const date = new Date(value).getTime();
    const diff = (now - date) / 1000; // diferencia en segundos

    // if (diff < 60) return 'justo ahora';
    if (diff < 60) return '1 min';
    if (diff < 3600) return Math.floor(diff / 60) + ' min';
    if (diff < 86400) return Math.floor(diff / 3600) + ' h';
    if (diff < 2592000) return Math.floor(diff / 86400) + ' d';
    if (diff < 31104000) return Math.floor(diff / 2592000) + ' mes';

    return Math.floor(diff / 31104000) + ' a'; // años
  }

}
